import React from 'react';
import { Navbar, Badge, Image, Button, MenuItem, DropdownButton } from 'react-bootstrap';
import logout from '../../includes/img/logout-black.svg';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import message from "../../includes/img/message.svg";
import { CONTACT_LIST } from '../containers/MobileContact/routes';
import { EMPTY_COUNT } from '../../utils/constants';
import { ORDER_LIST } from '../containers/MobileOrders/routes';
import { FAQ } from '../containers/Main/pageRoutes';

const MobileHeader = (props) => {

    const BadgeCount = EMPTY_COUNT < props.unread && <Badge className="bg-red badge-notif" onClick={()=>props.history.push(CONTACT_LIST)}>{props.unread}</Badge>;
    
    const redirectTo = (path) => {
        props.history.push(path)
    }

    const headerTitle = () => {
        if (props.withReturn) {
            return (
                <span className="header-title-mobile" onClick={props.returnAction}>
                    <Button bsStyle="link" className="mobile-module-return" >
                        <FontAwesomeIcon icon="angle-left" className="mobile-header-icons"/>
                    </Button>
                    {props.mobilePage}
                </span>
            )
        } else {
            return <span className="header-title-mobile">{props.mobilePage}</span>
        }
    }

    return (
        <Navbar inverse className="header-green-mobile">
            <Navbar.Header className="header-base full-width">
                <Navbar.Brand>{headerTitle()}</Navbar.Brand>
                <div className="pull-right mt-5">
                    <Button
                        bsStyle={"link"}
                        className="mobile-header-icon"
                        onClick={() => props.history.push(ORDER_LIST)}
                    >
                        <FontAwesomeIcon className="mobile-header-icons mt-4" icon="shopping-cart" />
                    </Button>

                    {BadgeCount}
                    
                    <Link className="mobile-header-icon" to={CONTACT_LIST}>
                        <Image src={message} alt="message-icon" width={30} />
                    </Link>

                    <span className="mobile-header-dropdown">
                        <DropdownButton
                            id="mobile-user"
                            className="mobile-header-icon"
                            bsStyle={"link"}
                            title={<FontAwesomeIcon className="mobile-header-icons" icon="user-circle" />}
                            noCaret
                        >
                            <MenuItem><span className="mobile-username">{props.user.user_nm}</span></MenuItem>
                            <MenuItem onClick={() => redirectTo(FAQ)}><span className="mobile-username" >ヘルプ</span></MenuItem>
                            <MenuItem onClick={props.toggleConfirmation.bind(this, true)}>
                                <Image src={logout} alt="logout-icon" width={25} className="mr-15"/>
                                ログアウト
                            </MenuItem>
                        </DropdownButton>
                    </span>
                </div>
            </Navbar.Header>
        </Navbar>
    );
};           

export default MobileHeader;